import { Card } from "primereact/card";
import { BsFlagFill } from "react-icons/bs";
import React, { useEffect, useState, forwardRef, useImperativeHandle } from 'react'
import { setindex30s } from "store/perFormExam/perFormExam";
import PropTypes from 'prop-types';
// import './exam.scss';
import { useSelector, useDispatch } from 'react-redux';
import { setTextCountDown, settime5s } from "store/perFormExam/perFormExam";
const CountdownV2 = ((props, _ref) => {
  let { onChange } = props;
  const [count, setCount] = useState(props.time || 0);
  const dispatch = useDispatch();

  useEffect(() => {

    const interval = setInterval(() => {
      setCount((data) => {
        let newCount = data - 1;
        onChange(newCount);
        return newCount;
      })
    }, 1000);
    return () => {
      clearInterval(interval);
    };
  }, []);

  useEffect(() => {
    setCount(props.time);
    
  }, [props.time]);

  function format(time) {
    let hours = Math.floor(time / 3600);
    let minutes = Math.floor((time % 3600) / 60);
    let seconds = time % 60;
    hours = hours.toString().padStart(2, '0');
    minutes = minutes.toString().padStart(2, '0');
    seconds = seconds.toString().padStart(2, '0');

    const formattedTime = `${hours}:  ${minutes}: ${seconds}`;

    if (time > 0) {
      // const action = setTextCountDown(formattedTime);
      // dispatch(action);
      return formattedTime;
    }
    else {
      // const action = setTextCountDown('HẾT GIỜ')
      // dispatch(action);
      // window.location.href = 'examdetail';
      return 'HẾT GIỜ'
    }

  }
  return (
    <div className="displayedTime" style={{ marginRight: '0.5em' }}
    >
      <div style={{ color: count < 30 ? 'red' : 'black', fontSize: '20px', fontWeight: '700' }}>{format(count)}</div>
    </div>
  )
})

CountdownV2.propTypes = {
  onChange: PropTypes.func,
};
CountdownV2.defaultProps = {
  onChange: () => { },
}
export { CountdownV2}
